import React, {Fragment} from 'react';
import {Helmet} from 'react-helmet';

export const ArticleSchema = (props) => {
    const {
        datePublishedCustom,
        sys: {firstPublishedAt, publishedAt},
        heroFile,
        systemData: {humanReadableName, siteName},
        headline,
        canonical,
    } = props;
    const logoUrl = `https://csvcus.homeaway.com/rsrcs/cdn-logos/3.4.0/bce/moniker/${siteName}/logo-bceheader.png`;

    return (
        <Fragment>
            <Helmet>
                <script type="application/ld+json">
                    {`{
                        "@context": "http://schema.org",
                        "@type": "Article",
                        "genre": "travel",
                        "mainEntityOfPage": {
                            "@type": "WebPage",
                            "@id": "${canonical}"
                        },
                        "datePublished": "${
                            datePublishedCustom || firstPublishedAt
                        }",
                        "dateModified": "${publishedAt}",
                        "headline": "${headline}",
                        "author": {
                            "@type": "Organization",
                            "name": "${humanReadableName}"
                        },
                        "publisher": {
                            "@type": "Organization",
                            "name": "${humanReadableName}",
                            "logo": {
                                "@type": "ImageObject",
                                "url": "${logoUrl}"
                            }
                        }
                        ${heroFile ? `,"image": "${heroFile.url}"` : ''}
                    }`}
                </script>
            </Helmet>
        </Fragment>
    );
};

export default ArticleSchema;
